import * as React from 'react';

interface IProps {
    children?: React.ReactNode;
    enableToggleAll?: boolean;
    onToggleAll?: () => void;
    renderSortDropdown?: () => JSX.Element;
    onCustomFilterChange?: (event: any) => void;
    customFilterValue?: string;
    actionButtons?: any;
}

export default class TableActions extends React.Component<IProps, any> {
    private renderToggleAll = (): JSX.Element | boolean | undefined => {
        const { enableToggleAll, onToggleAll } = this.props;

        return (
            enableToggleAll &&
            onToggleAll && (
                <label className="checkbox">
                    <input type="checkbox" onClick={onToggleAll} style={{ marginRight: '5px' }} /> Select all
                </label>
            )
        );
    };

    private renderSortDropDown = (): JSX.Element | boolean | undefined => {
        const { renderSortDropdown } = this.props;

        return renderSortDropdown && renderSortDropdown();
    };

    private renderSearchField = (): JSX.Element => {
        const { onCustomFilterChange, customFilterValue } = this.props;
        if (!onCustomFilterChange || customFilterValue === null) {
            return <></>;
        }
        return (
            <div className="level-item">
                <div className="field table-search" style={{ marginBottom: 0 }}>
                    <div className="control is-expanded has-icons-left">
                        <input
                            className="input is-small"
                            type="text"
                            placeholder="Search"
                            onChange={onCustomFilterChange}
                            value={customFilterValue}
                        />
                        <span className="icon is-small is-left">
                            <i className="fa fa-search" />
                        </span>
                    </div>
                </div>
            </div>
        );
    };

    private renderActions = () => {
        return <div className="level-item">{this.props.actionButtons()}</div>;
    };

    public render() {
        const { actionButtons } = this.props;

        return (
            <div className="level is-marginless table-actions">
                <div className="level-left">
                    <div className="level-item">{this.renderToggleAll()}</div>
                    <div className="level-item">{this.props.children}</div>
                </div>
                <div className="level-right">
                    {this.renderSearchField()}
                    {actionButtons && this.renderActions()}
                    <div className="level-item">{this.renderSortDropDown()}</div>
                </div>
            </div>
        );
    }
}
